export default __webpack_public_path__ + "static/media/black-arrow-up.06892c88.svg";